module.exports = __webpack_public_path__ + "static/media/10000steps-main-img.2c83e268.png";